import { NextApiRequest, NextApiResponse } from 'next'

import { HttpMethod, HttpStatus } from '../httpConstants'

type TApiServiceResponse = Promise<void | NextApiResponse<any>>

type THttpMethodHandler = () => TApiServiceResponse

type THttpMethodHandlersConfig = {
    getHandler?: THttpMethodHandler
    postHandler?: THttpMethodHandler
    putHandler?: THttpMethodHandler
    patchHandler?: THttpMethodHandler
    deleteHandler?: THttpMethodHandler
    headHandler?: THttpMethodHandler
}

const serviceHttpMethodSwitch = async (
    request: NextApiRequest,
    response: NextApiResponse,
    {
        getHandler,
        postHandler,
        putHandler,
        patchHandler,
        deleteHandler,
        headHandler,
    }: THttpMethodHandlersConfig,
): Promise<NextApiResponse | void | undefined> => {
    const { method } = request

    try {
        switch (method) {
            case HttpMethod.GET:
                return await getHandler?.()

            case HttpMethod.POST:
                return await postHandler?.()

            case HttpMethod.PUT:
                return await putHandler?.()

            case HttpMethod.PATCH:
                return await patchHandler?.()

            case HttpMethod.DELETE:
                return await deleteHandler?.()

            case HttpMethod.HEAD:
                return await headHandler?.()

            default:
                return response.status(HttpStatus.ClientError.NOT_FOUND_404).end()
        }
    } catch (exception) {
        return response.status(HttpStatus.ServerError.INTERNAL_500).end()
    }
}

export type { TApiServiceResponse, THttpMethodHandler, THttpMethodHandlersConfig }
export { serviceHttpMethodSwitch }
